import axios from 'axios'
import isEmpty from 'lodash/isEmpty'
import { formatDate } from '../../../../utils/time'

export default {
  initOrder: async ({ commit, dispatch }) => {
    commit('setShowLoadData', true)
    let result = await axios.post('/order/getOrderData', {
      command: {
        name: 'initOrder'
      }
    })
    commit('setPersonalTypeList', result.data.personType)
    commit('setProfileList', result.data.profile)
    commit('setUserInfoList', result.data.userFields)
    commit('setDeliveryTypeList', result.data.delivery.typeList)
    commit('setDeliveryCountryList', result.data.delivery.countryList)
    commit('setDeliveryFieldList', result.data.delivery.fields)
    commit('setDeliveryServiceFieldList', result.data.delivery.serviceFields)
    commit('setDeliveryItems', result.data.delivery.deliveryList)
    commit('setDeliveryPickupItems', result.data.delivery.pickup)
    commit('setPaymentData', result.data.payments)
    commit('setPrice', result.data.price)
    commit('setBasketData', result.data.basket)
    dispatch('setMoving', result.data.moving)
    commit('setIsAuthorized', result.data.isAuthorized)
    commit('setShowLoadData', false)
  },
  setPersonalTypeById: async ({ commit }, id) => {
    commit('setShowLoadData', true)
    let result = await axios.post('/order/getOrderData', {
      command: {
        name: 'setPersonalType',
        data: id
      }
    })

    commit('setPersonalTypeList', result.data.personType)
    commit('setProfileList', result.data.profile)
    commit('setUserInfoList', result.data.userFields)
    commit('setDeliveryTypeList', result.data.delivery.typeList)
    commit('setDeliveryCountryList', result.data.delivery.countryList)
    commit('setDeliveryFieldList', result.data.delivery.fields)
    commit('setDeliveryServiceFieldList', result.data.delivery.serviceFields)
    commit('setDeliveryItems', result.data.delivery.deliveryList)
    commit('setDeliveryPickupItems', result.data.delivery.pickup)
    commit('setPaymentData', result.data.payments)
    commit('setPrice', result.data.price)
    commit('setShowLoadData', false)
  },
  setProfileById: async ({ commit, getters, dispatch }, id) => {
    commit('setShowLoadData', true)
    const data = {
      fields: getters.getDeliveryFields,
      serviceFields: getters.getDeliveryServiceFields,
      profileId: id
    }
    let result = await axios.post('/order/getOrderData', {
      command: {
        name: 'setProfile',
        data: data
      }
    })
    commit('setProfileList', result.data.profile)
    commit('setUserInfoList', result.data.userFields)
    commit('setDeliveryTypeList', result.data.delivery.typeList)
    commit('setDeliveryCountryList', result.data.delivery.countryList)
    commit('setDeliveryFieldList', result.data.delivery.fields)
    commit('setDeliveryServiceFieldList', result.data.delivery.serviceFields)
    commit('setDeliveryItems', result.data.delivery.deliveryList)
    commit('setDeliveryPickupItems', result.data.delivery.pickup)
    commit('setPaymentData', result.data.payments)
    dispatch('setMoving', result.data.moving)
    commit('setPrice', result.data.price)
    commit('setShowLoadData', false)
  },
  setDeliveryCountryById: async ({ commit, dispatch }, id) => {
    commit('setShowLoadData', true)
    const data = {
      countryId: id
    }

    let result = await axios.post('/order/getOrderData', {
      command: {
        name: 'setDeliveryData',
        data: data
      }
    })

    commit('setDeliveryTypeList', result.data.delivery.typeList)
    commit('setDeliveryCountryList', result.data.delivery.countryList)
    commit('setDeliveryFieldList', result.data.delivery.fields)
    commit('setDeliveryServiceFieldList', result.data.delivery.serviceFields)
    commit('setDeliveryItems', result.data.delivery.deliveryList)
    commit('setDeliveryPickupItems', result.data.delivery.pickup)
    dispatch('setMoving', result.data.moving)
    commit('setPaymentData', result.data.payments)
    commit('setPrice', result.data.price)
    commit('setShowLoadData', false)
  },
  setDeliveryTypeById: async ({ commit, getters, dispatch }, id) => {
    commit('setShowLoadData', true)
    let result = await axios.post('/order/getOrderData', {
      command: {
        name: 'setDeliveryData',
        data: {
          deliveryTypeId: id,
          fields: getters.getDeliveryFields,
          serviceFields: getters.getDeliveryServiceFields
        }
      }
    })
    commit('setDeliveryTypeList', result.data.delivery.typeList)
    commit('setDeliveryCountryList', result.data.delivery.countryList)
    commit('setDeliveryFieldList', result.data.delivery.fields)
    commit('setDeliveryServiceFieldList', result.data.delivery.serviceFields)
    commit('setDeliveryItems', result.data.delivery.deliveryList)
    dispatch('setMoving', result.data.moving)
    commit('setDeliveryPickupItems', result.data.delivery.pickup)
    commit('setPaymentData', result.data.payments)
    commit('setPrice', result.data.price)
    commit('setShowLoadData', false)
  },
  updateDeliveryFields: async ({ commit, getters, dispatch }) => {
    commit('setShowLoadData', true)
    const data = {
      fields: getters.getDeliveryFields,
      serviceFields: getters.getDeliveryServiceFields
    }

    let result = await axios.post('/order/getOrderData', {
      command: {
        name: 'setDeliveryData',
        data: data
      }
    })

    commit('setDeliveryTypeList', result.data.delivery.typeList)
    commit('setDeliveryCountryList', result.data.delivery.countryList)
    commit('setDeliveryFieldList', result.data.delivery.fields)
    commit('setDeliveryServiceFieldList', result.data.delivery.serviceFields)
    commit('setDeliveryItems', result.data.delivery.deliveryList)
    commit('setDeliveryPickupItems', result.data.delivery.pickup)
    dispatch('setMoving', result.data.moving)
    commit('setPaymentData', result.data.payments)
    commit('setPrice', result.data.price)
    commit('setShowLoadData', false)
  },
  setDeliveryItemById: async ({ commit, getters, dispatch }, id) => {
    commit('setShowLoadData', true)
    let result = await axios.post('/order/getOrderData', {
      command: {
        name: 'setDeliveryData',
        data: {
          deliveryId: id,
          fields: getters.getDeliveryFields,
          serviceFields: getters.getDeliveryServiceFields
        }
      }
    })
    commit('setDeliveryItems', result.data.delivery.deliveryList)
    commit('setDeliveryPickupItems', result.data.delivery.pickup)
    commit('setDeliveryFieldList', result.data.delivery.fields)
    commit('setDeliveryServiceFieldList', result.data.delivery.serviceFields)
    dispatch('setMoving', result.data.moving)
    commit('setPaymentData', result.data.payments)
    commit('setPrice', result.data.price)
    commit('setShowLoadData', false)
  },
  setPaymentById: async ({ commit, getters }, id) => {
    commit('setShowLoadData', true)
    const deliveryData = {
      fields: getters.getDeliveryFields,
      serviceFields: getters.getDeliveryServiceFields
    }
    const paymentData = {
      selectedId: id,
      isInnerSelected: getters.getIsInnerPaymentSelected
    }
    let result = await axios.post('/order/getOrderData', {
      command: {
        name: 'setPayment',
        data: {
          payment: paymentData,
          delivery: deliveryData
        }
      }
    })

    commit('setPaymentData', result.data.payments)
    commit('setPrice', result.data.price)
    commit('setShowLoadData', false)
  },
  setPaymentInner: async ({ commit, getters }) => {
    commit('setShowLoadData', true)
    const deliveryData = {
      fields: getters.getDeliveryFields,
      serviceFields: getters.getDeliveryServiceFields
    }
    const selectedId = getters.getSelectedPayments === undefined
      ? null
      : getters.getSelectedPayments.id
    const paymentData = {
      selectedId: selectedId,
      isInnerSelected: !getters.getIsInnerPaymentSelected
    }

    let result = await axios.post('/order/getOrderData', {
      command: {
        name: 'setPayment',
        data: {
          payment: paymentData,
          delivery: deliveryData
        }
      }
    })

    commit('setPaymentData', result.data.payments)
    commit('setPrice', result.data.price)
    commit('setShowLoadData', false)
  },
  setBasketItemCount: async ({ commit, getters, dispatch }, { id, count }) => {
    commit('setShowLoadData', true)
    let result = await axios.post('/order/getOrderData', {
      command: {
        name: 'setBasketCountItem',
        data: {
          basket: {
            id: id,
            count: count
          },
          delivery: {
            fields: getters.getDeliveryFields,
            serviceFields: getters.getDeliveryServiceFields
          }
        }
      }
    })
    commit('setDeliveryItems', result.data.delivery.deliveryList)
    dispatch('setMoving', result.data.moving)
    commit('setPrice', result.data.price)
    commit('setBasketData', result.data.basket)
    commit('setPaymentData', result.data.payments)
    commit('setShowLoadData', false)
  },
  saveOrder: async ({ getters, commit }) => {
    commit('setShowLoadData', true)
    commit('clearGlobalErrors')
    const selectedPaymentId = getters.getSelectedPayments === undefined
      ? null
      : getters.getSelectedPayments.id
    let getDeliveryPickupItemSelectedID = getters.getDeliveryPickupItemSelected === undefined
      ? null
      : getters.getDeliveryPickupItemSelected.id
    let result = await axios.post('/order/getOrderData', {
      command: {
        name: 'saveOrder',
        data: {
          personalTypeId: getters.getPersonalTypeSelected.id,
          userInfo: getters.getUserInfo,
          paymentId: selectedPaymentId,
          isInnerPayment: getters.getIsInnerPaymentSelected,
          deliveryId: getters.getDeliveryItemSelected.id,
          deliveryPickupItemId: getDeliveryPickupItemSelectedID,
          deliveryFields: getters.getDeliveryFields,
          deliveryFieldsService: getters.getDeliveryServiceFields,
          profileId: getters.getSelectedProfile.id,
          deliveryTypeId: getters.getDeliveryTypeSelected.id,
          accountFields: getters.getAccountInfo
        }
      }
    })
    if (result.data['error'] !== undefined) {
      commit('addGlobalErrors', result.data['error'])
    } else {
      window.yaCounter38734440.reachGoal('send-order')
      if (selectedPaymentId === 9) {
        window.location.href = `/personal/order/payment/?ORDER_ID=${result.data.orderId}&PAYMENT_ID=${result.data.orderId}`
      } else {
        window.location.href = `/personal/order/order_detail.php?ID=${result.data.orderId}`
      }
    }

    commit('setShowLoadData', false)
  },
  checkUpdateFields: async ({ getters, commit, dispatch }) => {
    const location = getters.getDeliveryFieldByCode('LOCATION').data.location
    if (location === '0000949228') {
      const street = getters.getDeliveryFieldByCode('STREET').value
      const house = getters.getDeliveryFieldByCode('HOUSE').value

      if (!isEmpty(house) && !isEmpty(street)) {
        const address = `${street} ${house}`
        commit('setDeliveryServiceFiledValueByCode', {
          code: 'ADDRESS',
          value: address
        })
        dispatch('updateDeliveryFields')
      }
    }
  },
  setMoving ({ commit, dispatch }, moving) {
    commit('setMoving', moving)
    dispatch('calculateMovingAvailability')
  },
  calculateMovingAvailability ({ getters, state, commit }) {
    let movingTime = 0
    for (let basketItem of state.basket.items) {
      if (getters.isStorePickup) {
        let moving = state.moving[getters.getDeliveryPickupItemSelected.id][basketItem.id]
        commit('setMovingAvailabilityByItem', {
          basketItemId: basketItem.id,
          availability: !!moving
        })
        movingTime = Math.max(movingTime, moving ? moving.time : 0)
      } else {
        let bestMoving = null
        let bestMovingCount = null
        for (let i in state.moving) {
          let moving = state.moving[i]
          let movingCount = Object.values(moving).filter(item => !!item).length
          if (!bestMoving || movingCount > bestMovingCount) {
            bestMoving = moving
            bestMovingCount = movingCount
          }
        }
        commit('setMovingAvailabilityByItem', {
          basketItemId: basketItem.id,
          availability: !!bestMoving && !!bestMoving[basketItem.id]
        })
        movingTime = Math.max(movingTime, bestMoving[basketItem.id] ? bestMoving[basketItem.id].time : 0)
      }
    }

    let isGlobalAvailable = true
    for (let i in state.movingAvailabilityByItem) {
      isGlobalAvailable = isGlobalAvailable && state.movingAvailabilityByItem[i]
    }

    if (!isGlobalAvailable) {
      commit('setMovingStatus', {
        success: false,
        message: '<div><b>Один из товаров недоступен ' +
          (getters.isStorePickup ? 'для самовывоза' : 'для доставки') + '</b></div>'
      })
    } else {
      // fix zero time moving
      movingTime = movingTime + 1
      // get hours
      const movingHours = Math.ceil(movingTime / 60)
      // calculate moving (+1 day if delivery)
      let movingDate = new Date()
      movingDate.setHours(movingDate.getHours() + movingHours + (getters.isStorePickup ? 0 : 24))
      // drop minutes
      movingDate.setMinutes(0)
      // format date
      let movingDateString = formatDate(movingDate)

      if (getters.isStorePickup) {
        movingDateString += ' После ' + movingDate.getHours().toString().padStart(2, '0') + ':' + movingDate.getMinutes().toString().padStart(2, '0')
      } else {
        movingDateString += ' ' + movingDate.getHours().toString().padStart(2, '0') + ':' + movingDate.getMinutes().toString().padStart(2, '0')
      }

      commit('setMovingStatus', {
        success: true,
        message: (getters.isStorePickup ? 'Самовывоз будет доступен - ' : 'Заказ будет передан в доставку - ') + movingDateString
      })
    }
  },
  validateRussianPostDelivery ({ getters, state, commit }) {
    commit('setValidateDelivery', getters.getDeliveryFieldByCode('ADDRESS_DOUBLE_RUSSIAN_POST').value &&
    getters.getDeliveryFieldByCode('ADDRESS_RUSSIAN_POST').value)
  }
}



// WEBPACK FOOTER //
// ./src/components/store/modules/order/actions.js